document.addEventListener('DOMContentLoaded', function() {
  // const selector = '.hubspot-popups-customize';

  const observer =  new MutationObserver(mutations => {
    mutations.forEach( mutation => {
      if (!mutation.addedNodes) return;

      for (let i = 0; i < mutation.addedNodes.length; i++) {
        const element = mutation.addedNodes[i];
        if (element.classList && element.classList.contains('leadinModal')) {
          console.log('element', element);

          const popupSettingsEl = document.querySelector(`[data-hspopup-id="${ element.getAttribute('id') }"]`);
          const popupStyle = popupSettingsEl.getAttribute('data-hspopup-style');
          // const popupDescription = popupSettingsEl.getAttribute('data-hspopup-description');

          element.classList.add(`leadinModal--style-${popupStyle}`);

          // break down title into smaller dom elements for styling purposes
          const headings = element.querySelectorAll('h1, h2, h3, h4, h5');

          headings.forEach(heading => {
            heading.innerHTML = heading.innerText.replace(/\w+:?/g, '<span>$&</span>');
          });

          // add description text below the form
          // const textEl = document.createElement('p');
          // textEl.classList.add('description-text')
          // textEl.innerText = popupDescription;

          // element.querySelector('.leadin-content-body').appendChild(textEl);
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  })
});



// WEBPACK FOOTER //
// ./scripts/components/hubspot-popups-customize.js